/* n2 matcha — free-sifter cart-watch (native Broadcast drawer)
   the "free sifter with 5+ teas" automatic discount zeroes one sifter once the cart holds
   5+ items from the Tea Powders collection — but only if a sifter is in the cart. the flight
   builder (n2-redesign.js) adds one itself; this watch covers every other path (product page,
   quick-add, collection cards) so the promise holds however the teas got there. it only ever
   removes a sifter it (or the flight) added — one the customer chose themselves is left alone.
   loaded after n2-redesign.js; the powder handle list is printed by snippets/n2-redesign.liquid. */
(function () {
  'use strict';
  if (window.__n2CartWatch) return; window.__n2CartWatch = true;

  var CFG = {
    sifterVariantId: 48576176947423,
    giftAt: 5,                        // tea powders needed for the free sifter (mirrors the automatic discount)
    giftProp: 'free with 5+ teas',    // line property marking a sifter this script (or the flight) added
    nudgeClass: 'n2-giftnudge',
    drawerFlag: 'n2-has-giftnudge',   // set on <cart-drawer> while our message shows; css hides the nz$100 nudge
    settleMs: 350                     // coalesce the burst of cart events one add fires into a single check
  };

  var HANDLES = null;
  function handles() {
    if (HANDLES) return HANDLES;
    var el = document.querySelector('[data-n2-powder-handles]');
    try { HANDLES = el ? JSON.parse(el.textContent) : []; } catch (e) { HANDLES = []; }
    return HANDLES;
  }
  function powderCount(cart) {
    var h = handles();
    return cart.items.reduce(function (n, i) {
      if (i.variant_id === CFG.sifterVariantId) return n;
      return h.indexOf(i.handle) >= 0 ? n + i.quantity : n;
    }, 0);
  }
  function write(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok; });
  }

  /* one write at a time, and never decide on a cart snapshot fetched before the last write
     landed — two overlapping refreshes must not both add a sifter. */
  var busy = false, lastWrite = 0, timer = null;
  /* resolves 'changed' | 'stale' | false */
  function sync(cart, fetchedAt) {
    if (busy || !handles().length) return Promise.resolve(false);
    if (fetchedAt < lastWrite) return Promise.resolve('stale');
    var powders = powderCount(cart);
    var sifters = cart.items.filter(function (i) { return i.variant_id === CFG.sifterVariantId; });
    var auto = sifters.filter(function (i) { return i.properties && i.properties._gift; });
    var w = null;
    if (powders >= CFG.giftAt && sifters.length === 0) {
      w = write('/cart/add.js', { items: [{ id: CFG.sifterVariantId, quantity: 1, properties: { _gift: CFG.giftProp } }] });
    } else if (powders < CFG.giftAt && auto.length) {
      w = write('/cart/change.js', { id: auto[0].key, quantity: 0 });
    }
    if (!w) return Promise.resolve(false);
    busy = true;
    return w.then(function (ok) {
      lastWrite = Date.now();
      busy = false;
      if (ok) document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      return ok ? 'changed' : false;
    }).catch(function () { lastWrite = Date.now(); busy = false; return false; });
  }

  function nudge(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var existing = drawer.querySelector('.' + CFG.nudgeClass);
    var hasSifter = cart.items.some(function (i) { return i.variant_id === CFG.sifterVariantId; });
    var show = handles().length > 0 && !hasSifter && powderCount(cart) === CFG.giftAt - 1;
    drawer.classList.toggle(CFG.drawerFlag, show);
    if (!show) { if (existing) existing.remove(); return; }
    if (existing) return;
    var box = document.createElement('div');
    box.className = CFG.nudgeClass;
    box.innerHTML = '<span class="' + CFG.nudgeClass + '__text">one more tea powder &amp; the <b>sifter</b> is on me.</span>';
    var items = drawer.querySelector('[data-items-holder]');
    if (items && items.parentNode) items.parentNode.insertBefore(box, items);
  }

  function refresh() {
    var fetchedAt = Date.now();
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return sync(cart, fetchedAt).then(function (result) {
          if (result === 'stale') schedule(CFG.settleMs);   /* look again with a fresh snapshot */
          else if (result !== 'changed') nudge(cart);       /* a change re-fires theme:cart:change → back through here */
        });
      })
      .catch(function () {});
  }
  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(refresh, ms);
  }
  document.addEventListener('theme:cart-drawer:open', function () { schedule(CFG.settleMs); });
  document.addEventListener('theme:cart:change', function () { schedule(CFG.settleMs); });
  document.addEventListener('theme:product:add', function () { schedule(CFG.settleMs); });
  document.addEventListener('theme:product:added', function () { schedule(CFG.settleMs); });
  if (!(window.Shopify && Shopify.designMode)) schedule(1500);   /* page load: settle carts edited elsewhere */
})();
